/**
 * Brand Constants (#745)
 *
 * Centralized brand name and trademark symbol.
 * Update BRAND_MARK from '™' to '®' when trademark is registered.
 */

export const BRAND_NAME = 'ORO move';
export const BRAND_MARK = '™'; // Change to '®' when registered
export const BRAND_FULL = `${BRAND_NAME}${BRAND_MARK}`;
